import { render, staticRenderFns } from "./MarriagesCard.vue?vue&type=template&id=3171f704&"
import script from "./MarriagesCard.vue?vue&type=script&lang=js&"
export * from "./MarriagesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports